import { gql } from '@apollo/client';

export const getUserArticleRelationsOfTypeInspire = gql`
  query getUserArticleRelationsOfTypeInspire($articleId: ID!, $userId: ID!) {
    userArticleRelations(
      where: {
        article: { id: { equals: $articleId } }
        user: { id: { equals: $userId }, deactivated: { equals: false } }
        relationType: { equals: inspire }
      }
    ) {
      id
    }
  }
`;
